module.exports = __webpack_public_path__ + "media/bootstrap-icons/type-1ab1999b.svg";